import Dialog from '@comp/Dialog/Dialog';
import useAppInstallAnalytics from '@hooks/useAppInstallAnalytics';

const RecordedVideoBlockDialog = ({ isOpen, onClose = () => {} }) => {
  const sendAapInstallAnalytics = useAppInstallAnalytics();
  const handleOpenPlayStore = () => {
    sendAapInstallAnalytics({
      button_text: 'Download now'
    });
    window.open(
      'https://play.google.com/store/apps/details?id=com.unacademyapp',
      '_blank'
    );
    onClose();
  };
  return (
    <Dialog
      type="default"
      dialogState={isOpen}
      onClose={onClose}
      acceptLabel="Download now"
      acceptLabelVariant="filled"
      acceptLabelTheme="black"
      acceptOnClick={handleOpenPlayStore}
      heading="Video lessons are available only on app"
      message="Please download the Unacademy app from Playstore"
      messageColor="var(--color-i-gray)"
    />
  );
};

export default RecordedVideoBlockDialog;
